export default {
  trainingPlan: {
    title: '训练计划',
    subtitle: '选择完美的训练计划，开始你的成功之旅',
    metaTitle: '训练计划 - Running Wild',
    metaDescription: '为各级别跑者提供全面的训练计划。从5K到马拉松，获得包含详细周训练的个人化训练计划。',
    recommended: '推荐',
    weeks: '周',
    distance: '距离',
    targetTime: '目标时间',
    startPlan: '开始此计划',
    backToPlans: '返回计划列表',
    trainingZones: '训练区域',
    weeklySchedule: '每周计划',
    selectWeek: '选择周',
    setGoal: '设定目标',
    setRaceGoal: '设定比赛目标',
    goalDescription: '设定比赛日的目标完赛时间。这将帮助定制您的训练计划。',
    targetHours: '目标小时',
    hoursPlaceholder: '小时',
    minutesPlaceholder: '分钟',
    secondsPlaceholder: '秒',
    saveGoal: '保存目标',
    cancel: '取消',
    invalidTime: '请输入有效的时间。',
    goalSaved: '目标保存成功！',
    readyToStart: '准备开始？',
    actionSubtitle: '选择下一步开始您的训练之旅',
    startTrainingDesc: '开始训练计划',
    setGoalDesc: '定义目标完成时间',
    downloadPlanDesc: '将计划保存到设备',
    sharePlan: '分享计划',
    sharePlanDesc: '与朋友分享',
    goalSet: '目标已设定',
    clearGoal: '清除目标',
    goalCleared: '目标清除成功！',
    week: '周',
    startTraining: '开始训练',
    downloadPlan: '下载计划',
    downloadSuccess: '训练计划"{planName}"已成功下载！',
    downloadError: '请先选择一个训练计划。',
    planOverview: '计划概览',
    goalTime: '目标时间',
    goalStatus: '目标状态',
    active: '活跃',
    // Additional keys for TrainingPlan.vue
    targetPace: '目标配速',
    goalAdjusted: '目标调整',
    noTraining: '无训练',
    recoveryAndRestDay: '恢复和休息日',
    days: {
      monday: '星期一',
      tuesday: '星期二',
      wednesday: '星期三',
      thursday: '星期四',
      friday: '星期五',
      saturday: '星期六',
      sunday: '星期日'
    },
    startTrainingMessage: '开始您的训练计划！',
    shareError: '未选择要分享的计划',
    shareCopied: '链接已复制到剪贴板！',
    sharePrompt: '复制此链接:'
  },
  home: {
    heroTitle: '灵活、可定制的全运动赛事规则平台',
    heroSubtitle: '创建带有自定义配速、心率、时间和任何 Strava 支持运动的赛事。',
    getStarted: '立即开始',
    seeHowItWorks: '了解如何运作',
    featuresTitle: '为什么选择我们的平台？',
    subscriptionPlans: '订阅计划',
    subscriptionDesc: '选择适合您跑步旅程的完美计划',
    recommended: '推荐',
    month: '月',
    save: '节省',
    unlimitedActivities: '无限活动追踪',
    aiAnalysis: 'AI智能分析',
    prioritySupport: '优先支持',
    subscribeNow: '立即订阅',
    plan: '套餐',
    duration: '时长',
    totalPrice: '总价',
    pricePerMonth: '每月',
    youSave: '您可节省',
    paymentInstructions: '付款说明',
    bankTransfer: '银行转账',
    bankName: '银行名称',
    accountNumber: '账号',
    accountName: '账户名称',
    amount: '金额',
    transferNote: '转账备注（重要！）',
    transferNoteDesc: '转账时请务必填写此备注:',
    copy: '复制',
    noteWarning: '没有此备注，我们无法验证您的付款！',
    scanQrCode: '扫描二维码',
    qrCodeDesc: '使用您的银行应用扫描此二维码:',
    qrNote: '二维码包含账户信息。记得添加转账备注！',
    activationTime: '激活时间',
    activationDesc: '我们验证您的付款后，您的订阅将在24小时内激活。激活后您的个人资料上将显示PRO徽章。',
    activationContact: '如有任何问题，请联系我们：',
    enterStravaId: '输入您的Strava ID',
    stravaIdDesc: '请输入您的Strava运动员ID。您可以在Strava个人资料的URL中找到它。',
    stravaIdPlaceholder: '例如：12345678',
    invalidStravaId: '请输入有效的数字Strava ID',
    howToFindStravaId: '如何找到您的Strava ID：',
    goToProfile: '前往您的个人资料',
    stravaIdInUrl: '并查看URL（例如：strava.com/athletes/12345678）',
    subscribingAs: '订阅身份',
    stravaIdRequired: '请输入您的Strava ID。',
    invalidStravaIdError: '请输入有效的数字Strava ID。',
    missingInfo: '信息缺失',
    invalidInput: '无效输入',
    paymentNote: '订阅激活后您将收到通知。',
    rateLimitError: '请求过多。请稍后再试。',
    errorContact: '如果问题仍然存在，请联系我们：',
    cancel: '取消',
    paymentMade: '我已完成付款',
    copiedToClipboard: '已复制到剪贴板！',
    paymentReceived: '付款确认',
    paymentConfirmMessage: '谢谢！我们验证您的付款后，您的订阅将在24小时内激活。',
    activePlan: '有效套餐',
    pendingPlan: '付款确认中',
    suspendedPlan: '订阅已暂停',
    status: '状态',
    activeStatus: '有效',
    pendingStatus: '待处理',
    validPeriod: '有效期',
    daysRemaining: '剩余天数',
    days: '天',
    pendingMessage: '感谢您的付款！我们正在处理您的订阅。',
    pendingTimeline: '我们确认付款后，您的订阅将在24小时内激活。激活后您将收到通知。',
    needHelp: '需要帮助？',
    pendingContact: '联系我们的客服团队',
    suspendedMessage: '您的订阅已被暂停。请在下方选择新套餐以继续享受高级功能。',
    suspendedContact: '如有疑问，请联系我们',
    paymentError: '提交付款确认时出错。请联系客服。',
    error: '错误',
    featureCustomRules: '自定义规则引擎',
    featureCustomRulesDesc: '设置配速、心率、时间范围等，让赛事规则灵活多变。',
    featureMultiSport: '多运动支持',
    featureMultiSportDesc: '不仅仅是跑步！我们支持游泳、骑行及 Strava 的所有运动类型。',
    featureRuleCustomization: '规则自定义',
    featureRuleCustomizationDesc: '自定义配速、心率、海拔、活跃天数等。特定时间跑步可获得2倍、3倍积分！',
    featureTrainingPlans: '训练计划',
    featureTrainingPlansDesc: '为半程马拉松和全程马拉松提供专业的训练计划，包含结构化训练和目标设定。',
    trackYourGoal: '设定目标',
    trackYourGoalDesc: '明确目标，并默默坚持追逐。',
    howItWorksTitle: '操作流程',
    howStep1: '创建赛事',
    howStep2: '定义自定义规则',
    howStep3: '邀请参与者',
    howStep4: '跟踪结果与庆祝',
    topAthletes: '顶尖运动员',
    topEvents: '热门赛事',
    participants: '参与者',
    eventsCreated: '已创建赛事',
    sportsSupported: '支持运动类型',
    ctaTitle: '准备好创建属于你的赛事了吗？',
    ctaDesc: '立即开始，体验最灵活的赛事平台。',
    trainingPlansTitle: '专业训练计划',
    trainingPlansSubtitle: '选择我们专家设计的半程马拉松和全程马拉松训练计划。每个计划都包含结构化训练、目标设定和进度跟踪。',
    halfMarathonPlan: '半程马拉松计划',
    halfMarathonPlanDesc: '21.1公里距离的16周结构化训练计划',
    fullMarathonPlan: '全程马拉松计划',
    fullMarathonPlanDesc: '42.2公里距离的16周全面训练计划',
    weeks: '周',
    distance: '距离',
    targetTime: '目标时间',
    startTrainingPlan: '开始训练计划',
    footerText: '版权所有。',
    about: '关于我们',
    contact: '联系我们',
    latestActivity: '最新活动',
    // Special Features Section
    specialFeatures: '特色功能',
    specialFeaturesDesc: '发现专为跑者设计的独特工具',
    makeKorlorTitle: 'MakeKorlor',
    makeKorlorDesc: '从您的GPX文件创建精美的动画路线视频，支持音乐同步',
    trainingPlanTitle: '训练计划',
    trainingPlanDesc: '5K、10K、半程马拉松和全程马拉松的个性化训练计划',
    uploadGpx: '上传GPX文件',
    addMusic: '添加背景音乐',
    animateRoute: '动画路线',
    exportVideo: '导出动画视频',
    weeklySchedules: '周计划',
    goalSetting: '目标设定',
    progressTracking: '进度跟踪',
    exportPlans: '导出计划',
    tryMakeKorlor: '试用MakeKorlor',
    startTraining: '开始训练',
    // Login CTA Section
    redirectingToFeed: '正在跳转到您的活动动态...',
    joinCommunity: '加入我们的跑步社区！',
    loginBenefit: '与跑友连接，追踪进度，享受专属功能',
    connectRunners: '与跑友连接',
    trackProgress: '追踪进度',
    exclusiveFeatures: '专属功能',
    loginNow: '使用Strava登录',
    freeToJoin: '免费且只需几秒钟！'
    ,
    // Subscription & AI Coach additions
    aiCoachTitle: '解锁你的AI跑步教练',
    aiCoachSubtitle: '让每次跑步都转化为可执行洞察。更聪明训练、避免平台期、冲击PB。',
    seePlans: '查看方案与价格',
    learnMore: '了解更多',
    weeklyVolume: '每周里程',
    easyPace: '轻松配速',
    sleepRecovery: '恢复分',
    formSignal: '动作信号',
    stable: '稳定',
    compareTitle: '为什么选择PRO？',
    free: '免费',
    pro: 'PRO',
    freeBasicTracking: '基础追踪',
    freeHistory: '仅近期历史',
    freeCommunity: '社区动态',
    proSmartInsights: '每次跑后智能洞察',
    proPersonalPlans: '个性化训练提醒',
    proFormSignals: '技术与努力信号',
    proTrendlines: '趋势与进度追踪',
    proPrioritySupport: '优先支持',
    faqTitle: '常见问题',
    // AI hero points
    aiPointPersonalizedInsightsTitle: '个性化洞察',
    aiPointPersonalizedInsightsDesc: '每次跑后获得简单可执行的建议。',
    aiPointTrainSmarterTitle: '更聪明地训练',
    aiPointTrainSmarterDesc: '自适应提醒帮你进步不透支。',
    aiPointSeeProgressTitle: '看见真实进步',
    aiPointSeeProgressDesc: '趋势线清晰展示真正改善之处。',
    aiPointStayMotivatedTitle: '保持动力',
    aiPointStayMotivatedDesc: '里程碑与连续天数帮助你坚持。',
    // How it works (subscription AI)
    howConnectTitle: '连接你的活动',
    howConnectDesc: '像平常一样跑步。我们会自动同步并分析。',
    howAnalyzeTitle: 'AI 分析模式',
    howAnalyzeDesc: '我们检测配速、努力与稳定性的趋势。',
    howGuidanceTitle: '获得清晰指导',
    howGuidanceDesc: '下次跑步即可应用的简短建议。',
    // FAQ
    faqQ1: 'AI分析如何帮助我跑得更好？',
    faqA1P1: '我们将复杂的数据总结成简单的提示：该做什么、少做什么或改变什么。',
    faqA1P2: '您将看到几周内的模式，而不仅仅是单次训练。',
    faqQ2: 'PRO适合初学者吗？',
    faqA2P1: '是的。指导用通俗易懂的语言编写，专注于简单的下一步行动。',
    faqA2P2: '它帮助新手和经验丰富的跑者避免停滞不前。',
    faqQ3: '支付后我会得到什么？',
    faqA3P1: '您的订阅将在验证后24小时内激活。',
    faqA3P2: '您将看到PRO徽章，并自动解锁AI洞察。',
    faqQ4: '我可以随时取消吗？',
    faqA4P1: '可以。您的计划会持续到付费期结束，然后停止。',
    faqA4P2: '没有隐藏费用。'
  },
  eventDetail: {
    title: '赛事详情',
    selectLevel: '请选择你的级别',
    selectTeam: '请选择你的队伍',
    enterPaceTarget: '请输入你的配速目标',
    invalidPaceTarget: '请输入有效的配速目标，例如：5p30 或 5p00',
    codeMismatch: '验证码错误 / 验证码不匹配',
    joinCode: '加入码',
    level: '级别',
    team: '队伍',
    personalTarget: '个人目标',
    paceTarget: '目标配速（5m30）',
    paceFormatHelp: '格式：5m30 或 5m00',
    join: '加入',
    dashboard: '仪表盘',
    teamDashboard: '团队仪表盘',
    upcoming: '即将开始',
    expired: '已结束',
    active: '进行中',
    scoringRules: '计分规则',
    error: '错误',
    varDashboard: '汇总表'
  },
  profile: {
    updateSuccess: '个人资料更新成功！',
    updateFailed: '个人资料更新失败',
    success: '成功',
    error: '错误',
    validationError: '验证错误',
    pleaseFixValidationErrors: '请在提交前修正验证错误',
    athleteNotFound: '未找到运动员',
    pleaseLoginAgain: '请重新登录以更新个人资料',
    redirectingToLogin: '未找到认证信息。正在重定向到Strava登录...',
    achievementLoadFailed: '成就加载失败',
    id: 'ID:',
    email: '邮箱:',
    athlete_name: '姓名:',
    total_activities: '总活动数:',
    proMember: '专业会员 - 高级订阅已激活',
    noChallenges: '暂无挑战',
    joinChallenges: '加入精彩挑战，开启你的健康之旅！',
    editProfile: '编辑资料',
    save: '保存',
    saving: '保存中...',
    optional: '可选',
    emailAddress: '邮箱地址',
    emailPlaceholder: '请输入你的邮箱地址',
    invalidEmail: '请输入有效的邮箱地址。',
    // Profile configuration fields
    age: '年龄',
    agePlaceholder: '请输入你的年龄',
    invalidAge: '请输入有效的年龄（1-120）',
    weight: '体重',
    weightPlaceholder: '请输入你的体重',
    invalidWeight: '请输入有效的体重（1-500 kg）',
    height: '身高',
    heightPlaceholder: '例如：168',
    heightHelp: '请输入你的身高（单位：厘米，例如：168 cm）',
    invalidHeight: '请输入有效的身高（50-300 cm）',
    gender: '性别',
    selectGender: '选择性别',
    genderMale: '男性',
    genderFemale: '女性',
    genderUnknown: '未知',
    invalidGender: '请选择性别',
    autoAnalyseAndShare: '自动分析并分享到Strava',
    autoAnalyseAndShareHelp: '当您创建新活动时，自动生成AI分析并分享到Strava',
    trainingTarget: '训练目标',
    trainingTargetHelp: '设定比赛目标以追踪进度',
    targetFinishTime: '目标完成时间',
    targetFinishTimeHelp: '例如：全程马拉松破4小时，输入4小时0分钟',
    targetRaceDate: '目标比赛日期',
    targetRaceDateHelp: '您的目标比赛是什么时候？ (格式: MM-DD-YYYY)',
    targetSportTypes: '目标运动类型',
    targetSportTypesHelp: '选择您想要训练的运动项目（按住Ctrl/Cmd键可多选）',
    goalDescription: '目标描述',
    goalDescriptionPlaceholder: '描述您的训练目标、您想要达成的目标、目标赛事或任何具体目标...',
    goalDescriptionHelp: '此描述将被AI用于提供更个性化的训练分析',
    sportRunning: '跑步',
    sportCycling: '骑行',
    sportSwimming: '游泳',
    sportTriathlon: '铁人三项',
    hours: '小时',
    minutes: '分钟',
    hoursPlaceholder: '时',
    minutesPlaceholder: '分',
    myChallenges: '我的挑战',
    upcoming: '即将开始',
    ended: '已结束',
    active: '进行中',
    start: '开始',
    end: '结束',
    viewDetails: '查看详情',
    dashboard: '仪表盘',
    myAchievement: '我的成就',
    loadingMoreChallenges: '正在加载更多挑战...',
    loadingAchievement: '正在加载成就...',
    noAchievementData: '暂无成就数据。',
    activityList: '活动列表',
    type: '类型',
    name: '名称',
    date: '日期',
    km: '公里',
    movingTime: '时间',
    pace: '配速',
    showStats: '显示统计',
    hideStats: '隐藏统计',
    count: '数量',
    block: '区块',
    blocks: '区块',
    points: '积分',
    changeAvatar: '更换头像',
    uploadAvatar: '上传头像',
    dragDropOrClick: '拖拽图片到此处，或点击选择',
    supportedFormats: '支持格式: JPG, PNG, GIF (最大5MB)',
    fileSizeError: '文件大小必须小于5MB',
    selectedFile: '已选择的文件',
    noFileSelected: '请选择要上传的文件',
    avatarUploadSuccess: '头像上传成功！',
    avatarUploadFailed: '头像上传失败',
    sessionExpired: '您的会话已过期，请重新登录。',
    authenticationRequired: '需要身份验证',
    aiGen: 'AI Gen',
    aiImageGen: '生成图片',
    aiVideoGen: '生成视频',
    aiTracklogStats: 'AI轨迹统计',
    dailyAiAnalysisLimitExceeded: '您已达到每日AI分析限制。请明天再试。',
    aiAnalysisError: 'AI分析错误',
    aiAnalysisThinking: 'AI正在思考...',
    aiAnalysisThinkingDescription: '正在将当前活动与您最近的公开数据进行比较',
    comparisonPeriod: '比较期',
    activitiesAnalyzed: '分析活动数',
    loadingAiGen: '正在加载AI生成数据...',
    tracklogList: '轨迹日志列表',
    tracklogName: '轨迹日志名称',
    dateTime: '日期时间',
    actions: '操作',
    noTracklogData: '暂无轨迹日志数据。',
    aiGeneratedImage: 'AI生成图片',
    aiGeneratedVideo: 'AI生成视频',
    generatingImage: '正在生成AI图片...请稍等或你可以去AI生成标签页查看进度',
    generatingVideo: '正在生成AI视频...请稍等或你可以去AI生成标签页查看进度',
    aiGeneratedFor: 'AI生成对象',
    generatedOn: '生成时间',
    downloadImage: '下载图片',
    downloadVideo: '下载视频',
    openInNewTab: '在新标签页中打开',
    shareImage: '分享图片',
    shareVideo: '分享视频',
    onlyMe: '仅自己',
    makePublic: '公开',
    privacyUpdated: '隐私设置已更新',
    privacyUpdateFailed: '隐私设置更新失败',
    uploadSourceImage: '上传源图片',
    dragDropImage: '拖拽图片到此处或点击选择',
    changeImage: '更换图片',
    uploadingImage: '正在上传图片...',
    invalidFileType: '无效的文件类型，请选择图片文件。',
    fileTooLarge: '文件过大，最大大小为10MB。',
    uploadFailed: '文件上传失败',
    videoNotSupported: '您的浏览器不支持video标签。',
    // AI History
    myAiHistory: '我的AI历史',
    loadingAiHistory: '正在加载AI历史...',
    errorLoadingAiHistory: 'AI历史加载失败',
    noAiHistory: '暂无AI历史',
    generateAiContent: '为您的活动生成AI内容以在此查看！',
    refreshAiHistory: '刷新AI历史',
    refresh: '刷新',
    startPolling: '自动刷新',
    stopPolling: '停止自动刷新',
    autoRefreshing: '自动刷新中...',
    aiHistoryUpdated: 'AI历史已更新',
    updateNotification: '更新',
    pollingStopped: '由于错误已停止自动刷新',
    pollingError: '连接错误',
    // No activities modal
    noActivitiesModalTitle: '未找到活动',
    tooFewActivities: '活动太少',

    noActivitiesModalMessage: '您还没有同步任何活动。同步您的Strava活动以在此查看，或加入活动以跟踪新活动。',
    tooFewActivitiesMessage: '您没有足够的活动来生成AI内容。请同步您的Strava活动以在此查看，或加入活动以跟踪新活动。',

    tooFewActivitiesModalSyncSuccess: '活动同步成功！',
    noActivitiesModalSyncActivities: '同步所有活动',

    tooFewActivitiesModalSyncActivities: '同步所有活动',
    noActivitiesModalExploreEvents: '探索活动',

    tooFewActivitiesModalExploreEvents: '探索活动',
    noActivitiesModalClose: '关闭',

    tooFewActivitiesModalClose: '关闭',
    noActivitiesModalSyncing: '正在同步活动...',

    tooFewActivitiesModalSyncing: '正在同步活动...',
    noActivitiesModalSyncSuccess: '活动同步成功！',
    noActivitiesModalSyncStarted: '活动同步已开始！这可能需要几分钟。',

    tooFewActivitiesModalSyncStarted: '活动同步已开始！这可能需要几分钟。',
    noActivitiesModalSyncError: '活动同步失败',

    tooFewActivitiesModalSyncError: '活动同步失败',
    syncInProgressTitle: '同步中',

    noActivitiesModalSyncFeature: '同步所有Strava活动以在此查看',
    tooFewActivitiesModalSyncFeature: '同步所有Strava活动以在此查看',

    noActivitiesModalJoinEventsFeature: '加入带有自定义规则和挑战的活动',
    tooFewActivitiesModalJoinEventsFeature: '加入带有自定义规则和挑战的活动',

    noActivitiesModalTrackProgressFeature: '跟踪您的进度和成就',
    tooFewActivitiesModalTrackProgressFeature: '跟踪您的进度和成就',
    activityId: '活动ID',
    contentType: '内容类型',
    status: '状态',
    contentUrl: '内容URL',
    contentTitle: '内容',
    contentText: '内容',
    viewAnalysis: '查看分析',
    updatedAt: '更新时间',
    createdAt: '创建时间',
    viewContent: '查看内容',
    noContent: '无内容',
    previous: '上一页',
    next: '下一页',
    showingResults: '显示第{start}-{end}条，共{total}条结果',
    unknown: '未知',
    statusTitle: '状态',
    // Preview functionality
    preview: '预览',
    previewContent: '预览内容',
    open: '打开',
    loadingContent: '正在加载内容...',
    failedToLoadContent: '加载内容失败',
    tapToZoom: '点击放大',
    daily_ai_generation_limit_exceeded: '已达到每日AI生成限制。请明天再试。跑更多活动以获得更多积分（即将推出 ^.^）',
    aiStatus: {
      started: '已开始',
      finished: '已完成',
      failed: '失败',
      processing: '处理中',
      error: '错误'
    },
    // Privacy controls
    privacy: '隐私',
    public: '公开',
    private: '私有',
    makePrivate: '设为私有',
    contentMadePublic: '内容已设为公开',
    contentMadePrivate: '内容已设为私有',
    notAvailable: 'N/A',
    // Additional missing keys
    uploadImageForAiImage: '上传AI生成图片',
    dragDropImageForAiImage: '拖拽图片到此处或点击选择用于AI生成',
    uploadingAvatar: '正在上传头像...'
  },
  progress: {
    title: '进度跟踪器',
    loading: '加载进度数据中...',
    totalDistance: '总距离',
    totalTime: '总时间',
    activities: '活动',
    totalElevation: '总爬升',
    avgPace: '平均配速',
    avgHR: '平均心率',
    longestRun: '最长跑步',
    longestRide: '最长骑行',
    byType: '按类型分类活动',
    weeklyTrend: '每周趋势',
    noData: '该时段没有活动数据',
    errorLoadingProgress: '加载进度数据错误',
    unknown: '未知',
    last7Days: '过去7天',
    last30Days: '过去30天',
    last90Days: '过去90天',
    eventPeriod: '赛事期间',
    customRange: '自定义范围',
    vsPreviewPeriod: '与上期对比',
    daysRemaining: '剩余天数',
    progressComplete: '完成'
  },
  events: {
    error: '错误',
    title: '赛事',
    noEvents: '暂无可用赛事',
    join: '加入',
    upcoming: '即将开始',
    expired: '已结束',
    loading: '正在加载赛事...',
    loadMore: '加载更多赛事'
  },
  login: {
    title: '登录',
    brand: 'Nghiện Chạy Bộ',
    welcome: '欢迎加入我们的社区！',
    instruction: '点击“使用Strava登录”按钮，开启你的跑步之旅，与大家一起分享成就！',
    loginWithStrava: '使用Strava登录',
    redirecting: '正在跳转...',
    step1: '点击上方的“使用Strava登录”按钮',
    guideAlt: '登录指南',
    step2: '选择“Authorize”以允许nghienchaybo.com同步你的Strava数据',
    step3: '之后，你的Strava数据将自动同步到nghienchaybo.com',
    error: '登录错误'
  },
  eventVar: {
    group: '分组',
    activityName: '活动名称',
    teamName: '队伍名称',
    pace: '配速',
    distance: '距离',
    movingTime: '移动时间',
    elapsedTime: '总用时',
    avgHR: '平均心率',
    avgWatts: '平均瓦特',
    elevHigh: '最高海拔',
    elevLow: '最低海拔',
    avgCadence: '平均步频',
    inspectionResults: '检测结果',
    noSimilarActivities: '未找到类似活动。',
    pageSize: '每页组数：',
    close: '关闭',
    // MISSING KEYS FROM ENGLISH (translated to Chinese):
    loading: '正在加载团队统计...',
    error: '数据加载错误',
    retry: '重试',
    export: '导出CSV',
    exportCSV: '导出为CSV',
    refresh: '刷新',
    searchPlaceholder: '按姓名或队伍搜索...',
    allTeams: '所有队伍',
    allGenders: '所有性别',
    male: '男性',
    female: '女性',
    clearFilters: '清除筛选',
    teamStats: '团队统计',
    rank: '排名',
    athlete: '选手',
    gender: '性别',
    team: '队伍',
    totalAthletes: '共{count}名选手',
    showing: '显示{count} / {total}名选手',
    previous: '上一页',
    next: '下一页',
    largeScreenTitle: '建议在大屏幕上查看',
    largeScreenMessage: '本页面包含详细统计和表格，建议在桌面或平板电脑上浏览以获得最佳体验。',
    featureTable: '完整数据列的表格视图',
    featureFilters: '高级搜索和筛选选项',
    featureExport: '导出为CSV格式',
    continueAnyway: '仍要继续',
    teamDashboard: '团队仪表盘',
    eventDashboard: '赛事仪表盘',
    inspection: '检测',
    inspectionLoading: '正在分析轨迹...',
    inspectionSubtitle: '本节显示具有相似路线或可疑模式的活动分组。每组可能表示重复或异常。',
    showingGroups: '显示第{from}–{to}组，共{total}组',
    jumpToPage: '页码：'
  },
  eventDashboard: {
    var: 'Var',
    io: 'I/O',
    dateTime: '日期时间',
    soiiReport: 'Soii/举报',
    inSportWeTrust: '运动让我们信任！放轻松 (^.^)',
    failedInspection: '加载检测结果失败。',
    // MISSING KEYS FROM ENGLISH (translated to Chinese):
    title: '赛事仪表盘',
    filter: '筛选与搜索',
    level: '级别',
    overall: '总榜',
    female: '女性',
    male: '男性',
    team: '队伍',
    search: '搜索',
    searchPlaceholder: '输入选手姓名...',
    ranking: '排名',
    participants: '{count} 位参与者',
    page: '第 {current}/{total} 页',
    points: '积分',
    actions: '操作',
    inspect: '查看',
    cert: '证书',
    next: '下一页',
    prev: '上一页',
    first: '首页',
    last: '末页',
    results: '条结果',
    join: '加入',
    stats: '统计',
    total: '总计',
    type: '类型',
    name: '姓名',
    date: '日期',
    km: '公里',
    pace: '配速',
    report: '举报',
    activityDetails: '活动详情',
    totalPoints: '总积分:',
    totalKm: '总公里:',
    totalDays: '总天数:',
    summaryByType: '按类型汇总（{count}条活动）：',
    number: '#',
    teamName: '队伍名称',
    levelName: '级别名称',
    eventName: '赛事名称',
    eventDates: '{from} - {to}',
    statusUpcoming: '即将开始',
    statusExpired: '已结束',
    statusActive: '进行中',
    activityList: '活动列表',
    viewOnStrava: '在Strava查看',
    resetFilters: '重置所有筛选',
    loadingAthletes: '正在加载选手...',
    times: '次'
  },
  teamEventDashboard: {
    loadingMoreTeams: '正在加载更多队伍...',
    noTeamsFound: '未找到队伍',
    noTeamsJoined: '尚无队伍加入此赛事。',
    // MISSING KEYS FROM ENGLISH (translated to Chinese):
    title: '团队赛事仪表盘',
    noTeams: '暂无可用队伍',
    join: '加入队伍',
    team: '队伍',
    teams: '队伍列表',
    members: '成员',
    points: '积分',
    rank: '排名',
    upcoming: '即将开始',
    expired: '已结束',
    teamsCount: '{count} {teamLabel}',
    loadingTeams: '正在加载队伍...'
  },
  nav: {
    brand: 'NCB',
    home: '首页',
    events: '赛事',
    trainingPlans: '训练计划',
    gpxAnimator: 'GPX动画生成器',
    eventVar: '赛事Var',
    guide: '登录指南',
    login: '登录',
    profile: '个人资料',
    profileLabel: '个人资料',
    logout: '登出',
    blog: '博客',
    about: '关于我们',
    createEvent: '创建赛事'
  },
  app: {
    brand: 'nghienchaybo.com',
    tagline: '虚拟体育 | 健康科技 - 2025',
    powered: '由 Strava 提供 | 测试中',
    home: '首页',
    backToTop: '返回顶部',
    contactUs: '联系我们',
    email: '邮箱',
    phone: '电话',
    affiliateTitle: '合作网站',
    affiliateYoutube: '👨‍💻 跟 Ahaxu 一起学编程 👨‍💻',
    affiliate42x: '42xChallenge.Com',
    copyright: '版权所有，侵权必究。'
  },
  eventMap: {
    loadingMap: '正在加载地图...'
  },
  feed: {
    title: '活动动态',
    loadMore: '加载更多活动',
    welcomeBack: '欢迎回来，{name}！',
    athlete: '运动员',
    stayConnected: '与您的跑步社区保持联系',
    joinEvent: '参加活动',
    profile: '个人资料',
    aiYourProfile: 'AI你的个人资料',
    recentActivity: '最近活动',
    loadingActivities: '正在加载活动...',
    aiGenerated: 'AI生成',
    viewFullSize: '查看完整尺寸',
    noRecentActivities: '没有最近的活动',
    followAthletes: '关注一些运动员或参加活动以在此查看活动',
    exploreEvents: '探索活动',
    quickTools: '快捷工具',
    makeKorlor: 'MakeKorlor',
    trainingPlans: '训练计划',
    activityImage: '活动图片',
    activity: '活动',
    aiGeneratedImage: 'AI生成图片',
    aiGeneratedVideo: 'AI生成视频',
    videoNotSupported: '您的浏览器不支持HTML5视频。'
  },
  makeKorlor: {
    title: 'GPX 3D 动画生成器',
    subtitle: '使用3D动画和音乐同步可视化您的GPX轨迹',
    uploadGpx: '上传GPX文件',
    uploadGpxPlaceholder: '选择GPX文件进行动画...',
    addMusic: '添加音乐（可选）',
    addMusicPlaceholder: '选择音频文件...',
    animationSpeed: '动画速度：',
    markerSize: '标记大小：',
    play: '播放',
    pause: '暂停',
    reset: '重置',
    toggleSatellite: '切换卫星',
    toggleTerrain: '切换地形',
    toggleStreet: '切换街道',
    currentSpeed: '当前速度：',
    elevation: '海拔：',
    distance: '距离：',
    trackInfo: '轨迹信息',
    totalDistance: '总距离：',
    totalTime: '总时间：',
    avgSpeed: '平均速度：',
    maxSpeed: '最大速度：',
    loading: '正在处理GPX文件...',
    gpxLoaded: 'GPX文件加载成功！',
    musicLoaded: '音乐文件已加载！音乐将与动画速度同步。',
    defaultMusicLoaded: '默认音乐已加载！音乐将与动画速度同步。',
    errorLoadingGpx: '加载GPX文件时出错：',
    errorLoadingMusic: '加载音乐文件时出错：',
    noGpxFile: '请先加载GPX文件！',
    noTrackData: '没有轨迹数据可导出！',
    processing: '正在处理GPX文件...',
    exportSuccess: '轨迹数据导出成功！',
    speedUp: '🚀 快于平均水平！',
    speedDown: '😌 慢于平均水平',
    startPoint: '起点',
    endPoint: '终点',
    recordVideo: '录制视频',
    stopRecording: '停止录制',
    recording: '录制中',
    recordedVideo: '录制的视频',
    videoNotSupported: '您的浏览器不支持视频播放。',
    downloadVideo: '下载视频',
    shareVideo: '分享视频',
    onlyMe: '仅自己',
    makePublic: '公开',
    privacyUpdated: '隐私设置已更新',
    privacyUpdateFailed: '隐私设置更新失败',
    uploadSourceImage: '上传源图像',
    dragDropImage: '在此拖放图像或点击选择',
    changeImage: '更换图像',
    uploadingImage: '正在上传图像...',
    invalidFileType: '无效的文件类型。请选择图像文件。',
    fileTooLarge: '文件过大。最大大小为10MB。',
    uploadFailed: '文件上传失败',
    recordingStarted: '录制已开始！当浏览器提示时请选择您想要录制的内容。',
    recordingStopped: '录制已停止。',
    recordingCompleted: '视频录制完成！',
    recordingNotSupported: '您的浏览器不支持屏幕录制。',
    screenAccessDenied: '屏幕访问被拒绝。请允许屏幕共享。',
    mapNotFound: '未找到地图。请重试。',
    noVideoRecorded: '还没有录制任何视频。',
    videoDownloaded: '视频下载成功！',
    videoShared: '视频链接已复制到剪贴板！',
    forceStopRecording: '强制停止录制',
    forceStop: '强制停止',
    recordingForceStopped: '录制已强制停止',
    noRecordingData: '没有录制数据',
    recordingError: '录制错误: {error}',
    animationCompleted: '动画完成，正在停止录制',
    autoStoppingRecording: '动画后自动停止录制',
    autoSelecting: '自动选择',
    shouldAutoRecord: '应该自动录制此标签页',
    ifPrompted: '如果提示',
    selectThisTab: '选择"此标签页"或"Current tab"'
  }
}
